/* eslint-disable camelcase */
import { type UseQueryResult, useQuery } from 'react-query';
import { CustomerCompanyService } from '../../services/wealthlane-customer-services';

const useGetCustomerCompanyName = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<string | undefined, unknown> => {
  const customerCompanyName = useQuery(['getCustomerCompanyName'], async () => {
    return await handleRequest(
      CustomerCompanyService.getApiCustomerApiAppCustomerCompanyCurrentCompanyName()
    );
  });

  return customerCompanyName;
};

export default useGetCustomerCompanyName;
